module.exports = __webpack_public_path__ + "media/images/pic/materials_green-5ee46c6c2e070376ffb02ba72333dca7.svg";